// Mock data for prototype
export const MOCK = {
  user: {
    name: "Claudia Chen",
    initials: "CC",
    email: "claudia@venzyme.life",
    role: "Partner · Translational Med",
    company: "Venzyme.LIFE"
  },
  // Founder persona — for ?as=founder
  founder: {
    name: "Mira Patel",
    initials: "MP",
    email: "mira@helix.bio",
    role: "Founder / CEO",
    company: "Helix Therapeutics"
  },
  stats: {
    decksScreened: 142,
    shortlisted: 18,
    inDiligence: 7,
    passRate: 0.127,
    avgIAS: 68.4,
    pipelineValue: "$412M",
    monthDelta: "+14%"
  },
  companies: [
    { id: "helix", name: "Helix Therapeutics", type: "Therapeutic", stage: "Series A", ias: 82, status: "diligence", tech: "mRNA oncology", submitted: "Apr 14", sector: "Onc", inv: "$18M" },
    { id: "orbis", name: "Orbis Diagnostics", type: "Diagnostic", stage: "Seed", ias: 74, status: "shortlist", tech: "Cell-free DNA", submitted: "Apr 12", sector: "Dx",  inv: "$6M" },
    { id: "kiva",  name: "Kiva Biosystems", type: "Therapeutic", stage: "Series B", ias: 71, status: "shortlist", tech: "Synbio enzymes", submitted: "Apr 11", sector: "Enz", inv: "$34M" },
    { id: "meri",  name: "Meridian Neuro", type: "Therapeutic", stage: "Series A", ias: 69, status: "review", tech: "Small-molecule PD", submitted: "Apr 10", sector: "CNS", inv: "$22M" },
    { id: "cyto",  name: "Cytomer Labs", type: "Device", stage: "Seed", ias: 63, status: "review", tech: "Wearable biosensor", submitted: "Apr 09", sector: "Dev", inv: "$4M" },
    { id: "prox",  name: "Proximal Health", type: "Digital Health", stage: "Series A", ias: 58, status: "review", tech: "AI clinical ops", submitted: "Apr 08", sector: "DH",  inv: "$12M" },
    { id: "fern",  name: "Fernway Bio", type: "Therapeutic", stage: "Pre-seed", ias: 54, status: "pass", tech: "GLP-1 analog", submitted: "Apr 07", sector: "Met", inv: "$1M" },
    { id: "sent",  name: "Sentrix Imaging", type: "Device", stage: "Series B", ias: 76, status: "diligence", tech: "Photoacoustic imaging", submitted: "Apr 05", sector: "Img", inv: "$40M" },
    { id: "aurl",  name: "Auralis Dx", type: "Diagnostic", stage: "Seed", ias: 67, status: "shortlist", tech: "Acoustic otology", submitted: "Apr 03", sector: "Dx",  inv: "$5M" },
  ],
  activity: [
    { t: "2 min ago", who: "System", what: "Market research returned for Helix Therapeutics", kind: "info" },
    { t: "11 min ago", who: "Rahul Iyer", what: "Scored Orbis Diagnostics IAS 74", kind: "score" },
    { t: "54 min ago", who: "You", what: "Moved Sentrix Imaging to Diligence", kind: "move" },
    { t: "2 hr ago", who: "System", what: "3 new decks uploaded via partner portal", kind: "upload" },
    { t: "Yesterday", who: "Mei Tan", what: "Left 4 notes on Kiva Biosystems", kind: "note" },
  ],
  analysisFields: [
    { label: "Company", value: "Helix Therapeutics" },
    { label: "Stage", value: "Series A" },
    { label: "Modality", value: "mRNA lipid nanoparticle" },
    { label: "Indication", value: "Solid tumors (HER2+)" },
    { label: "Raise", value: "$18M" },
    { label: "Lead", value: "Undisclosed" },
  ],
  iasBreakdown: [
    { key: "Science",   score: 88, weight: .25 },
    { key: "Team",      score: 79, weight: .20 },
    { key: "Market",    score: 84, weight: .15 },
    { key: "IP",        score: 71, weight: .10 },
    { key: "Clinical",  score: 68, weight: .15 },
    { key: "Commercial",score: 74, weight: .10 },
    { key: "Financial", score: 82, weight: .05 },
  ],
  missing: [
    "Preclinical efficacy data package (studies, species, endpoints)",
    "CMC / manufacturing scale-up plan",
    "Composition-of-matter patent status and term",
    "Reimbursement strategy beyond US",
  ],

  // Thesis draft (auto-generated, editable)
  thesis: {
    verdict: "Worth a meeting",
    draft: "Helix is building a differentiated mRNA-LNP platform with unusually strong preclinical efficacy for a Series A — three-fold tumor regression in HER2+ xenografts exceeds published peers at this stage. Platform extensibility (claimed 4-indication pipeline) is plausible but unvalidated. Primary risk is IP: a single provisional with no composition-of-matter creates real exposure in a field where Moderna, BioNTech, and Arcturus hold dense coverage. Recommend a 45-minute call focused on IP strategy and CMC readiness before committing diligence hours.",
    author: "AI-drafted · edit to adopt",
    edited: false,
  },

  // Inline citations tie fields to slide numbers
  citations: {
    "Company name": { slide: 1, quote: "Helix Therapeutics" },
    "Modality":     { slide: 3, quote: "Proprietary lipid nanoparticle (LNP) + mRNA payload" },
    "Indication":   { slide: 4, quote: "Lead program: HLX-101 for HER2+ breast cancer" },
    "Stage":        { slide: 26, quote: "Series A · targeting $18M close Q2 2026" },
    "Raise":        { slide: 26, quote: "$18M at $72M pre-money" },
    "Preclinical":  { slide: 14, quote: "3.2x tumor volume reduction vs. vehicle, n=24" },
    "Team":         { slide: 18, quote: "14 FTE · 8 PhD · 2 ex-Moderna · 1 ex-BioNTech" },
    "IP":           { slide: 22, quote: "Provisional filed Dec 2024 · method-of-use" },
  },

  // Peer comparisons — real-feeling context
  peers: [
    { name: "Arbor RNA",      date: "Feb 2026", stage: "Series A", ias: 79, raise: "$22M", diff: "similar mRNA-LNP, oncology" },
    { name: "Veloce Bio",     date: "Jan 2026", stage: "Series A", ias: 76, raise: "$15M", diff: "same indication, different modality" },
    { name: "Carbide Tx",     date: "Nov 2025", stage: "Series A", ias: 71, raise: "$20M", diff: "LNP delivery, gene-editing payload" },
  ],

  // Decision log (investor view) + coaching queue (founder view)
  decisionLog: [
    { t: "14 min ago", who: "Claudia Chen", action: "Flagged IP as diligence priority", kind: "flag" },
    { t: "2 hr ago", who: "Rahul Iyer", action: "Moved to Diligence", kind: "move", from: "Shortlist", to: "Diligence" },
    { t: "1 day ago", who: "System", action: "IAS computed: 82 (+3 vs. peer median)", kind: "score" },
    { t: "1 day ago", who: "System", action: "Extraction complete · 0.87 confidence", kind: "system" },
  ],

  // Founder-facing coaching — what investors will ask
  coachingQueue: [
    {
      q: "Walk me through your composition-of-matter strategy.",
      why: "Your IP section lists one provisional. At Series A, investors expect either filed non-provisionals or a clear plan with timelines. This will be the first thing a life-sciences lead asks.",
      priority: "critical",
      slide: 22,
    },
    {
      q: "What's the manufacturing path from lab-scale LNP to GMP?",
      why: "CMC readiness is the #2 Series A gating question for nucleic-acid therapeutics. Your deck references a CMO partner but doesn't name them or describe scale.",
      priority: "critical",
      slide: 23,
    },
    {
      q: "How does your delivery compare to Moderna's and BioNTech's LNPs?",
      why: "Claiming a proprietary LNP invites this. Have a one-slide side-by-side ready with specific metrics (PDI, encapsulation efficiency, in vivo biodistribution).",
      priority: "high",
      slide: 3,
    },
    {
      q: "What are your preclinical endpoints for IND enablement?",
      why: "You show tumor regression — great. Investors will ask about the formal IND-enabling tox package: species, duration, dose-ranging, GLP status.",
      priority: "high",
      slide: 14,
    },
    {
      q: "Who is your clinical advisor for HER2+ patient selection?",
      why: "HER2+ is a crowded space (Enhertu, Kadcyla). A named KOL on your SAB materially de-risks patient-enrichment strategy.",
      priority: "medium",
      slide: 19,
    },
  ],

  // Founder-side "how investors scored you" translation
  founderAxes: [
    { key: "Science",    label: "Science & platform",     score: 88, band: "Top 15%",   note: "Unusually strong preclinical for Series A." },
    { key: "Team",       label: "Team",                   score: 79, band: "Top 30%",   note: "Solid technical bench. Consider adding commercial/BD hire." },
    { key: "Market",     label: "Market",                 score: 84, band: "Top 20%",   note: "HER2+ is validated but crowded. Position carefully." },
    { key: "IP",         label: "Intellectual property",  score: 71, band: "Bottom 50%",note: "Weakest axis. This is addressable — see questions." },
    { key: "Clinical",   label: "Clinical path",          score: 68, band: "Bottom 50%",note: "IND-enabling plan needs specificity." },
    { key: "Commercial", label: "Commercial",             score: 74, band: "Top 40%",   note: "Reasonable for this stage." },
    { key: "Financial",  label: "Financial plan",         score: 82, band: "Top 25%",   note: "Raise size and use-of-funds align with milestones." },
  ],
};
